module.exports = "https://static.wanderu.com/static/media/train-grey.165fd6ed.svg";